import { BOT_API, INTEGRATIONS_CONTACT_API } from '@/constants/api-endpoints';
import { apiInstance } from '@/utils';
import { ContactDetailsResponse, SalesforceContact, HubSpotContact } from '@/types/contact';

export const getContactByThreadId = async (threadId: string): Promise<ContactDetailsResponse> => {
  const response = await apiInstance({
    method: 'GET',
    url: BOT_API.getContact(threadId),
  });
  return response.data;
};

export const updateContactByThreadId = async (
  threadId: string,
  data: Partial<ContactDetailsResponse['contactInfo']>
): Promise<ContactDetailsResponse> => {
  const response = await apiInstance({
    method: 'PATCH',
    url: BOT_API.updateContact(threadId),
    data,
  });
  return response.data;
};

const getSalesforceContactByEmail = async (email: string): Promise<SalesforceContact> => {
  const response = await apiInstance({
    method: 'GET',
    url: INTEGRATIONS_CONTACT_API.getSalesforceContact(email),
  });
  return response.data;
};

const getHubSpotContactByEmail = async (email: string): Promise<HubSpotContact> => {
  const response = await apiInstance({
    method: 'GET',
    url: INTEGRATIONS_CONTACT_API.getHubSpotContact(email),
  });
  return response.data;
};
